(function () {
  if (window.__ccHeaderNavReveal) return;
  window.__ccHeaderNavReveal = true;

  var OPEN_INTENT = 90; // hover has to mean it
  var CLOSE_INTENT = 320; // ...and leaving has to mean it too

  function init() {
    var header = document.getElementById('header-component');
    if (!header || header.dataset.menuStyle === 'drawer') return;

    var columns = header.querySelector('.header__columns');
    var logo = header.querySelector('.header__column--center');
    var overflow = header.querySelector('.overflow-menu');
    if (!columns || !logo || !overflow) return;

    // The column is what moves, but it is NOT what we can measure: opening
    // collapses its grid track to 0px, so its box shrinks to nothing against
    // the logo's right edge while the logo itself renders leftward out of it.
    // The mark is the logo's own box, which keeps its width in both states.
    var mark = logo.querySelector('.header-logo') || logo;

    var openTimer, closeTimer, reduced;
    reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /**
     * FLIP the logo between its two grid positions. The track change is
     * instant, so we measure where it was, let it land, then start it from
     * the old place and let it travel to the new one.
     *
     * Measured on the logo, not on the column that carries it. Measuring the
     * column overstated the travel by exactly one logo width (318.6px of a
     * 234.4px move, at 1680px), which put the start frame a whole logo to the
     * left of where the logo actually was: the jolt left before the slide
     * right. The transform still rides on the column — that is what the grid
     * moves — but the distance comes from the box that does not collapse.
     */
    function move(setState) {
      var first = mark.getBoundingClientRect();
      setState();
      var last = mark.getBoundingClientRect();
      var delta = first.left - last.left;
      if (reduced || !delta) return;

      logo.style.transition = 'none';
      logo.style.transform = 'translateX(' + delta + 'px)';
      // Force the start frame before handing over to the transition.
      void logo.offsetWidth;
      // 720ms with a small settling overshoot; the curve and the reasoning
      // for its size live in header-nav-reveal.css.
      logo.style.transition = 'transform 720ms var(--ease-nav-settle, ease-out)';
      logo.style.transform = '';
    }

    /**
     * Hand the hidden items back to the visible slot ourselves rather than
     * waiting for the overflow-list to notice the extra width. It observes
     * its own size and would normally reflow, but it declined to when the
     * width was forced in testing — and a logo that slides aside to reveal
     * nothing is worse than no feature at all. On close they go back, which
     * is where the list would have put them anyway.
     */
    var stashed = [];

    function reveal() {
      stashed = Array.prototype.slice.call(overflow.querySelectorAll('[slot="overflow"]'));
      stashed.forEach(function (item, i) {
        item.slot = '';
        // Its place in the queue; the CSS turns this into the delay so the
        // items arrive one after another rather than all at once.
        item.style.setProperty('--reveal-i', i);
        item.dataset.navRevealed = 'true';
      });
    }

    function restash() {
      stashed.forEach(function (item) {
        item.slot = 'overflow';
        // Closing is not a performance — drop the staging so a reopen
        // starts its sequence from the beginning.
        delete item.dataset.navRevealed;
        item.style.removeProperty('--reveal-i');
      });
      stashed = [];
    }

    function open() {
      if (header.dataset.navOpen === 'true') return;
      move(function () {
        header.dataset.navOpen = 'true';
        reveal();
      });
    }

    function close() {
      if (header.dataset.navOpen !== 'true') return;
      move(function () {
        header.dataset.navOpen = 'false';
        restash();
      });
    }

    function moreItem() {
      // The More trigger lives in the light DOM, slotted into the shadow list.
      return overflow.querySelector('[slot="more"]');
    }

    function onEnter(event) {
      var trigger = event.target.closest && event.target.closest('[slot="more"]');
      if (!trigger) return;
      clearTimeout(closeTimer);
      openTimer = setTimeout(open, OPEN_INTENT);
    }

    function onClick(event) {
      var trigger = event.target.closest && event.target.closest('[slot="more"]');
      if (!trigger) return;
      event.preventDefault();
      clearTimeout(openTimer);
      clearTimeout(closeTimer);
      if (header.dataset.navOpen === 'true') close();
      else open();
    }

    overflow.addEventListener('pointerenter', onEnter, true);
    overflow.addEventListener('click', onClick, true);

    // Leaving the header closes it, after enough of a pause that crossing a
    // seam or clipping a corner does not count as leaving.
    header.addEventListener('pointerleave', function () {
      clearTimeout(openTimer);
      closeTimer = setTimeout(close, CLOSE_INTENT);
    });

    header.addEventListener('pointerenter', function () {
      clearTimeout(closeTimer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') close();
    });

    document.addEventListener('click', function (event) {
      if (header.dataset.navOpen !== 'true') return;
      if (!header.contains(event.target)) close();
    });

    // Keyboard users reach More by tab; opening on focus keeps the rest of
    // the nav reachable without a pointer.
    overflow.addEventListener(
      'focusin',
      function (event) {
        if (event.target.closest && event.target.closest('[slot="more"]')) open();
      },
      true
    );

    header.dataset.navOpen = 'false';
    void moreItem;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
